var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var initialStateMap = {
    open: 'SET_OPEN',
    opening: 'SET_OPENING',
    closed: 'SET_CLOSED',
    closing: 'SET_CLOSING'
};
export function getAction(status) {
    return initialStateMap[status];
}
export function reducer(state, action) {
    var _a, _b, _c;
    switch (action.type) {
        case 'SET_OPEN':
            return __assign(__assign({}, state), { status: 'open', height: (_a = action.height) !== null && _a !== void 0 ? _a : 0 });
        case 'SET_OPENING':
            return __assign(__assign({}, state), { status: 'opening', height: (_b = action.height) !== null && _b !== void 0 ? _b : 0 });
        case 'SET_CLOSED':
            return __assign(__assign({}, state), { status: 'closed', height: 0 });
        case 'SET_CLOSING':
            return __assign(__assign({}, state), { status: 'closing', height: 0 });
        case 'SET_HEIGHT':
            return __assign(__assign({}, state), { height: (_c = action.height) !== null && _c !== void 0 ? _c : 0 });
    }
}
//# sourceMappingURL=state.js.map